import React, { useState, useEffect, useRef } from "react";
import "../SelectZone/SelectZone.css";
import GoogleMapReact from "google-map-react";
import { styled } from "@mui/material/styles";
import { ReactComponent as Search } from "../../../assets/icons/search.svg";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Colours from "../../../data/colors";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import {
  createNewZone,
  deleteZoneById,
  fetchAllZones,
  updateZoneArea,
  updateZoneById,
} from "../../../services/zones.services";
import ZoneSettings from "../../../Components/ZoneSettings/ZoneSettings";
import ScreenLoader from "../../../Components/ScreenLoader/ScreenLoader";
import Confirm from "../../../Components/Popups/Confirm";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../store/common/snackBarSlice";
import { MdAdd } from "react-icons/md";
import AccordionItem from "./Components/AccordionItem";
import BottomExpandablePanel from "../../../Components/Common/BottomExpandablePanel";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
const Loader = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "50px",
        display: "flex",
        alignItems: "flex-end",
      }}
    >
      <div
        style={{
          width: "100%",
        }}
      >
        <LinearProgress />
      </div>
    </Box>
  );
};

const DeleteArea = ({ onClick }) => {
  const { t } = useTranslation("carrier");
  return (
    <div
      className="w-[25px] h-[25px] bg-ui-surface flex justify-center items-center cursor-pointer absolute z-[900000000000000] ml-[-15px] mt-[-5px] rounded-[50%]"
      onClick={onClick}
    >
      <LightTooltip placement="top" arrow title={t("zones.deleteArea")}>
        <DoNotDisturbOnIcon
          sx={{ color: "tomato", width: "100%", height: "100%" }}
        />
      </LightTooltip>
    </div>
  );
};
const AreaLabel = ({ name, color }) => {
  return (
    <>
      {name.length > 5 ? (
        <LightTooltip placement="top" arrow title={name}>
          <div
            className="w-[50px] h-3 text-[white] flex justify-center items-center cursor-pointer absolute z-[900000000000000] ml-[-25px] font-medium text-[9px] border -mt-2.5 px-2.5 py-1 rounded-md border-solid border-smoke"
            style={{ backgroundColor: color, borderColor: color }}
          >
            <FmdGoodIcon
              className="absolute text-3xl mb-[38px] "
              sx={{ color }}
            />
            {name.substr(0, 4)}..
          </div>
        </LightTooltip>
      ) : (
        <div
          className="w-[50px] h-3 text-[white] flex justify-center items-center cursor-pointer absolute z-[900000000000000] ml-[-25px] font-medium text-[9px] border -mt-2.5 px-2.5 py-1 rounded-md border-solid border-smoke"
          style={{ backgroundColor: color, borderColor: color }}
        >
          <FmdGoodIcon
            className="absolute text-3xl mb-[38px] "
            sx={{ color }}
          />
          {name}
        </div>
      )}
    </>
  );
};

const CreateZone = () => {
  const { t } = useTranslation("carrier");
  const [center, setCenter] = useState({
    lat: 45.508888,
    lng: -73.561668,
  });
  const [zones, setZones] = useState([]);
  const [creatingZone, setCreatingZone] = useState();
  const [zone, setZone] = useState({});
  const [screenLoader, setScreenLoader] = useState(false);
  const [disableZoneSave, setDisableZoneSave] = useState(true);
  const [mapKey, setMapKey] = useState(1);
  const [drawingManager, setDrawingManager] = useState({});
  const [editNameMode, setEditNameMode] = useState();
  const [expandedItem, setExpandedItem] = useState();
  const [confirmDeleteArea, setConfirmDeleteArea] = useState();
  const [confirmDeleteZone, setConfirmDeleteZone] = useState();
  const [newZone, setNewZone] = useState(false);
  const [maps, setMaps] = useState();
  const [markersLoaded, setMarkersLoaded] = useState(false);
  const [displayMap, setDisplayMap] = useState(true);
  const [map, setMap] = useState();
  const [colorPicker, setColorPicker] = useState(true);
  const [newZoneAdded, setNewZoneAdded] = useState(false);
  const [isDrawing, setDrawing] = useState(false);
  const [zoneDeleted, setZoneDeleted] = useState(false);
  const state = useSelector((state) => state);
  const [mapHeight, setMapHeight] = useState("calc(100vh - 58px)");

  const defaultProps = {
    center,
    zoom: 12,
  };
  const dispatch = useDispatch();

  const selectedZone = useRef();

  const zoneNameField = useRef();
  const zonesLoaded = useRef(false);
  const postalCodesRef = useRef([]);
  const zonesRef = useRef([]);
  const deleteMarkerRef = useRef([]);
  const zoneMarkerRef = useRef([]);
  const drawing = useRef(false);
  const drawingManagerRef = useRef(null);

  const handleApiLoaded = (mapData, mapsData) => {
    setMaps(mapsData);
    setMap(mapData);

    deleteMarkerRef.current = [];
    zoneMarkerRef.current = [];
    if (zones !== null && zones?.length > 0) {
      zones?.forEach((zoneObject) => {
        let color = zoneObject.color;
        zoneObject.coordinates?.forEach((crd) => {
          var myPolygon = new maps.Polygon({
            paths: crd,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
          });
          deleteMarkerRef.current = [
            ...deleteMarkerRef.current,
            { id: zoneObject.id, coords: crd[0] },
          ];
          zoneMarkerRef.current = [
            ...zoneMarkerRef.current,
            { color, name: zoneObject.name, coordinates: crd[1] },
          ];
          myPolygon.setMap(mapData);
        });
      });
    }
  };

  const handleAutoComplete = () => {
    const input = document.getElementById("locationSearch");
    var autocomplete = new maps.places.Autocomplete(input);
    var lat = "";
    var lng = "";
    maps.event.addListener(autocomplete, "place_changed", function () {
      var place = autocomplete.getPlace();
      lat = place.geometry.location.lat();
      lng = place.geometry.location.lng();
      setCenter({ lat, lng });
    });
  };
  const handleZoneTypeChange = (newType, id) => {
    if (!newZone) {
      setZone({
        ...zone,
        type: zone.type?.includes(newType)
          ? zone.type?.filter((type) => type !== newType)
          : zone.type !== null
          ? [...zone.type, newType]
          : [newType],
      });
      const updated = updateZone(
        {
          ...zone,
          type: zone.type?.includes(newType)
            ? zone.type?.filter((type) => type !== newType)
            : zone.type !== null
            ? [...zone.type, newType]
            : [newType],
          postal_codes: zone.postal_codes
            ? zone.postal_codes.map((ps) => ps.id)
            : [],
        },
        false,
        zone.id
      );
    } else {
      setNewZone({
        ...newZone,
        type: newZone.type?.includes(newType)
          ? newZone.type?.filter((type) => type !== newType)
          : newZone.type !== null
          ? [...newZone.type, newType]
          : [newType],
      });
    }
  };
  const handleCreateZone = () => {
    const availableColors = [];
    Colours.forEach((color) => {
      let colorExist = false;
      zones.forEach((zone) => {
        if (zone.color === color) colorExist = true;
      });
      if (!colorExist) availableColors.push(color);
    });
    const zone = {
      id: "newzone",
      name: ``,
      type: ["DELIVERY", "PICKUP"],
      color: availableColors.length > 0 ? availableColors[0] : "grey",
    };
    setZones([...zones, zone]);
    setNewZone(zone);
  };
  useEffect(() => {
    if (newZone && zoneNameField.length < 1) {
      zoneNameField.current.focus();
    }
  }, [newZone]);

  const createZone = async (e) => {
    e.stopPropagation();
    setCreatingZone(newZone.id);
    let data = newZone;
    delete data.id;
    const response = await createNewZone({
      ...data,
      color: newZone.color,
      postal_code_ids: [],
      coordinates: [],
    });
    if (!response.error) {
      getAllZones();
      setNewZoneAdded(response.data?.result);
      dispatch(
        showSnackBar({
          text: t("zones.newZoneCreatedSuccessfully"),
          severity: "success",
        })
      );
    } else {
      showSnackBar({
        text:
          response?.error?.response?.data?.message ?? t("zones.couldntCreateZone"),
        severity: "error",
      });
      getAllZones();
    }
    setCreatingZone(false);
    setEditNameMode(false);
    setNewZone(false);
  };
  const getAllZones = async () => {
    setScreenLoader(i18n.t("carrier:zones.fetchingZones"));
    const response = await fetchAllZones();
    if (response.data) {
      setZones(response.data.result);
      zonesRef.current = response.data.result;
    }
    setScreenLoader(false);
  };
  const deleteZoneArea = async (coords, zoneId) => {
    zones.forEach((zn) => {
      if (zn.id === zoneId) {
        zn.coordinates.forEach((crd) => {
          if (crd[0].lat === coords.lat && crd[0].lng === coords.lng) {
            const updated = setConfirmDeleteArea({
              zoneId: zn.id,
              coordinates: zn.coordinates.filter(
                (item) =>
                  item[0].lat !== coords.lat && item[0].lng !== coords.lng
              ),
              postalCodeIds: [],
            });
          }
        });
      }
    });
  };

  const deleteZone = async (id) => {
    setCreatingZone(id);
    const response = await deleteZoneById(id);
    zonesRef.current = zones.filter((item) => item.id !== id);
    if (response?.error === null) {
      setZones((zones) => zones.filter((item) => item.id !== id));
    }
    setCreatingZone(false);
  };
  const updateZone = async (data, loading, id, cb) => {
    loading && setCreatingZone(data.id);
    const response = await updateZoneById(data, id);
    if (response?.error === null) {
      getAllZones();
    }
    setCreatingZone(false);
    return response;
  };
  const reloadMap = async () => {
    setMapKey((prevKey) => prevKey + 1);
  };
  const deleteZoneRegion = async (data, cb) => {
    setConfirmDeleteArea(false);
    const response = await updateZoneArea(data);
    if (response?.error === null) {
      dispatch(
        showSnackBar({
          text: t("zones.areaDeletedSuccessfully"),
          severity: "success",
        })
      );
      const res = await getAllZones();
      reloadMap();
    } else {
      dispatch(
        showSnackBar({
          text:
            response?.error?.response?.data?.message ?? t("zones.somethingWentWrong"),
          severity: "error",
        })
      );
    }
    return response;
  };
  const handleNameChange = (e) => {
    e.stopPropagation();
    updateZone(
      {
        ...zone,
        postal_codes: zone.postal_codes
          ? zone.postal_codes.map((ps) => ps.id)
          : [],
      },
      true,
      zone.id
    );
    setEditNameMode(false);
  };

  const handleDeleteZone = async (e, id) => {
    e.stopPropagation();
    if (newZone.id === id) {
      setNewZone(false);
      setZones((prevZones) => prevZones.slice(0, -1));
      setExpandedItem();
      return;
    }
    setConfirmDeleteZone(id);
  };
  const handleColorChange = (color, zone) => {
    // console.log(color, zone);
    if (newZone?.id !== zone.id) {
      updateZone(
        {
          ...zone,
          color,
          postal_codes: zone.postal_codes
            ? zone.postal_codes.map((ps) => ps.id)
            : [],
        },
        true,
        zone.id
      );
    } else {
      setNewZone({ ...newZone, color }, true, zone.id);
      setZones(
        zones.map((zn) => {
          if (zone.id === zn.id) {
            return { ...zn, color };
          } else {
            return zn;
          }
        })
      );
    }
    setColorPicker(false);
  };
  const drawNewZoneArea = (szone) => {
    drawingManagerRef.current = drawingManager;
    drawingManager.setDrawingMode(maps.drawing.OverlayType.POLYGON);
    dispatch(
      showSnackBar({
        text: t("zones.clickOnMapToDraw"),
        severity: "info",
      })
    );

    drawing.current = szone;
    setDrawing(szone);
    selectedZone.current = szone;
  };
  const handleCancelDrawing = () => {
    drawingManagerRef.current.setDrawingMode(null);
    drawing.current = false;
    setDrawing(false);
  };

  const getZones = () => {
    if (zones !== null && zones?.length > 0) {
      zones?.forEach((zoneObject) => {
        let color = zoneObject.color;
        zoneObject.coordinates?.forEach((crd) => {
          var myPolygon = new maps.Polygon({
            paths: crd,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
          });
          deleteMarkerRef.current = [
            ...deleteMarkerRef.current,
            { id: zoneObject.id, coords: crd[0] },
          ];
          zoneMarkerRef.current = [
            ...zoneMarkerRef.current,
            { color, name: zoneObject.name, coordinates: crd[1] },
          ];
          myPolygon.setMap(map);
        });
      });
    }
  };
  const addRegion = async (coords, zone) => {
    setScreenLoader(t("zones.creatingArea"));
    var newArea = new maps.Polygon({
      paths: coords,
      strokeColor: zone.color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: zone.color,
      fillOpacity: 0.35,
    });
    const res = await updateZone(
      {
        coordinates: zone.coordinates
          ? [...zone.coordinates, coords]
          : [coords],
        // postal_codes: existedCodes,
        postal_codes: [],
      },
      false,
      zone.id
    );
    if (res?.error === null) {
      setZones((zn) => {
        return zn.map((item) => {
          if (item.id === zone.id) {
            return {
              ...zone,
              coordinates:
                zone.coordinates?.length > 0
                  ? [...zone.coordinates, coords]
                  : [coords],
              postal_codes: [],
            };
          } else {
            return item;
          }
        });
      });
    }

    newArea.setMap(map);
    deleteMarkerRef.current = [
      ...deleteMarkerRef.current,
      { id: zone.id, coords: coords[0] },
    ];
    zoneMarkerRef.current = [
      ...zoneMarkerRef.current,
      { color: zone.color, name: zone.name, coordinates: coords[1] },
    ];

    getZones();
    setScreenLoader(false);
    dispatch(
      showSnackBar({
        text: t("zones.areaAddedSuccessfully"),
        severity: "success",
      })
    );
  };
  function handleResize() {
    setMapHeight("calc(100vh - 58px)");
  }
  const _initMap = () => {
    const drawingManager = new maps.drawing.DrawingManager({
      drawingMode: null,
      drawingControl: false,
      drawingControlOptions: {
        position: maps.ControlPosition.TOP_CENTER,
        drawingModes: [maps.drawing.OverlayType.POLYGON],
      },
      markerOptions: {},
      polygonOptions: {
        strokeColor: selectedZone.current
          ? selectedZone.current.color
          : zone.color
          ? zone.color
          : "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: selectedZone.current
          ? selectedZone.current.color
          : zone.color
          ? zone.color
          : "#FF0000",
        fillOpacity: 0.35,
        clickable: true,
        dragable: true,
        editable: true,
        zIndex: 1,
      },
    });
    setDrawingManager(drawingManager);
    drawingManager.setMap(map);
    maps.event.addListener(map, "click", function (event) {
      if (drawingManager.getDrawingMode() !== null) {
        let latLng = event.latLng;
        if (!map.getBounds().contains(latLng)) {
          drawingManager.setDrawingMode(null);
          drawing.current = false;
          setDrawing(false);
        }
      }
    });
    maps.event.addListener(drawingManager, "overlaycomplete", function (event) {
      if (drawingManager.getDrawingMode() !== null) {
        let arr = event.overlay.getPath().getArray();
        let coords = [];
        arr.forEach((coord) => {
          coords.push({ lat: coord.lat(), lng: coord.lng() });
        });
        addRegion(coords, selectedZone.current, postalCodesRef.current);
        drawingManager.setDrawingMode(null);
        drawing.current = false;
        setDrawing(false);
      } else {
        reloadMap();
      }
    });
  };

  useEffect(() => {
    if (map && maps && maps?.drawing) {
      _initMap();
    }
  }, [maps, map, zone.color, zone]);

  useEffect(() => {
    if (zones.length > 0 && !zonesLoaded.current && map && maps) {
      getZones();
      zonesLoaded.current = true;
      zonesRef.current = zones;
    }
  }, [zones, maps, map, mapKey]);

  useEffect(() => {
    if (!newZone) {
      setDisableZoneSave(zone?.name ? zone?.name?.length < 1 : true);
    } else {
      setDisableZoneSave(newZone?.name ? newZone?.name?.length < 1 : true);
    }
  }, [zone.name, newZone]);
  useEffect(() => {
    getAllZones();
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      setCenter({
        lat: latitude,
        lng: longitude,
      });
    });
  }, []);
  useEffect(() => {
    setMapHeight("calc(100vh - 58px)");
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (zones.length > 0 && maps && map && !markersLoaded) {
      reloadMap();
      setMarkersLoaded(true);
    }
  }, [zones, maps]);
  useEffect(() => {
    setDrawing(drawing.current);
  }, [drawing.current]);
  useEffect(() => {
    if (zones.length > 0) {
      zonesRef.current = zones;
    }
  }, [zones]);

  useEffect(() => {
    if (zone.name !== "" && maps && map) {
      selectedZone.current = zone;
      _initMap();
    }
  }, [zone]);

  return (
    <>
      {displayMap && (
        <div
          className="w-full relative select-none overflow-hidden font-manrope"
          style={{ height: mapHeight }}
        >
          {(screenLoader || zoneDeleted) && (
            <ScreenLoader text={screenLoader} />
          )}
          {confirmDeleteArea && (
            <Confirm
              open={confirmDeleteArea}
              setOpen={setConfirmDeleteArea}
              handleConfirm={async () => {
                setScreenLoader(true);
                const res = await deleteZoneRegion(
                  confirmDeleteArea,
                  getAllZones
                );
                setScreenLoader(false);
              }}
              text={t("zones.confirmDeleteArea")}
            />
          )}
          {confirmDeleteZone && (
            <Confirm
              open={confirmDeleteZone}
              setOpen={setConfirmDeleteZone}
              handleConfirm={async () => {
                setConfirmDeleteZone(false);
                const res = await deleteZone(confirmDeleteZone);
                setZoneDeleted(true);
              }}
              text={t("zones.confirmDeleteZone")}
            />
          )}
          <div className="absolute z-10 w-[95%] max-w-[350px] overflow-hidden bg-ui-surface flex justify-evenly items-center shadow-soft-lg rounded-[7px] left-5 top-5">
            <input
              type="text"
              className="flex-1 h-10 outline-none bg-[white] px-2.5 py-0"
              placeholder={t("common:fields.searchCity")}
              id="locationSearch"
              onChange={handleAutoComplete}
            />
            <Search className="mr-3" />
          </div>
          <div className="absolute z-10 w-[350px] shadow-soft-md rounded-[7px] right-5 top-5 bg-ui-surface p-1">
            <div
              className={`w-full h-[45px] mb-1 flex justify-center  items-center font-medium text-sm bg-state-warning-solid rounded-sm text-white cursor-pointer ${
                newZone ? "pointer-events-none" : ""
              }`}
              onClick={handleCreateZone}
            >
              <MdAdd className="mr-2" size={20} /> {t("zones.createNewZone")}
            </div>

            {zones?.map((item, index) => {
              return (
                <>
                  {creatingZone !== item?.id && (
                    <AccordionItem
                      key={item.id}
                      item={item}
                      expandedItem={expandedItem}
                      setExpandedItem={setExpandedItem}
                      editNameMode={editNameMode}
                      newZone={newZone}
                      setEditNameMode={setEditNameMode}
                      handleNameChange={handleNameChange}
                      setColorPicker={setColorPicker}
                      colorPicker={colorPicker}
                      handleDeleteZone={handleDeleteZone}
                      zone={zone}
                      handleZoneTypeChange={handleZoneTypeChange}
                      isDrawing={isDrawing}
                      drawNewZoneArea={drawNewZoneArea}
                      handleCancelDrawing={handleCancelDrawing}
                      disableZoneSave={disableZoneSave}
                      createZone={createZone}
                      zoneNameField={zoneNameField}
                      setNewZone={setNewZone}
                      setZone={setZone}
                      handleColorChange={handleColorChange}
                    />
                  )}
                  {creatingZone === item?.id && <Loader />}
                </>
              );
            })}
            {zones?.length < 1 && (
              <div className="w-full h-[50px] flex justify-center items-center text-ui-text-muted text-xl border-t border-soft-gray">
                {t("zones.noZoneCreated")}
              </div>
            )}
          </div>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_GOOGLE_KEY,
              libraries: "drawing,places,geometry",
              v: "3.64",
            }}
            key={mapKey}
            center={defaultProps.center}
            zoom={defaultProps.zoom}
            options={{
              gestureHandling: "greedy",
              fullscreenControl: false,
            }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            libraries={["drawing", "places", "geometry"]}
          >
            {deleteMarkerRef.current.map((item) => (
              <DeleteArea
                lat={item.coords.lat}
                lng={item.coords.lng}
                onClick={() =>
                  deleteZoneArea(
                    { lat: item.coords.lat, lng: item.coords.lng },
                    item.id
                  )
                }
              />
            ))}
            {zoneMarkerRef.current.map((item) => (
              <AreaLabel
                lat={item.coordinates?.lat}
                lng={item.coordinates?.lng}
                name={item.name}
                color={item.color}
              />
            ))}
          </GoogleMapReact>
          <BottomExpandablePanel newZone={newZone}>
            <ZoneSettings
              zones={zones}
              newZoneAdded={newZoneAdded}
              setNewZoneAdded={setNewZoneAdded}
              zoneDeleted={zoneDeleted}
              setZoneDeleted={setZoneDeleted}
              maps={maps}
              map={map}
              reloadMap={reloadMap}
            />
          </BottomExpandablePanel>
        </div>
      )}
    </>
  );
};

export default CreateZone;
